export default "/3c8b4b44e260b086d6d6e6f33b1bb190.png";